'use strict';

const { h } = require('phy');
const { Provider } = require('preact-redux');
const { createStore } = require('redux');

function withReduxWrapper(component, data) {
  const store = createStore(() => data);

  return h(Provider, { store }, component);
}

module.exports = { withReduxWrapper };
